"use client";
import React from "react";
import { HeaderConfig } from "./IndustryBenifitsGrid";

export default function IndustryBenifitsHeaderSection({
  header,
  ctaButton,
}: {
  header: HeaderConfig;
  ctaButton?: React.ReactNode;
}) {
  return (
    <div className="flex flex-col items-start w-full gap-6">
      {/* Subtitle / Overline */}
      {header.subtitle && (
        <span className="text-white/60 uppercase tracking-widest text-[length:var(--primarybtn)] font-medium">
          {header.subtitle}
        </span>
      )}

      {/* Title & Description stacked full width */}
      <div className="flex flex-col justify-between w-full gap-8">
        <h2 className="text-white text-[length:var(--section-title)] font-medium clash-font capitalize leading-[100%]">
          {header.title}
        </h2>

        {header.description && (
          <p className="text-white/70 text-[length:var(--hero-para)] leading-[160%]">
            {header.description}
          </p>
        )}
      </div>
    </div>
  );
}
